import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';
import { VrstaZabraneComponent } from './vrsta-zabrane.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
  ],
  entryComponents: [VrstaZabraneComponent],
  declarations: [VrstaZabraneComponent],
  exports: [VrstaZabraneComponent],
})
export class VrstaZabraneModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/vrsta-zabrane/vrsta-zabrane.module.ts